import { Mark } from '@tiptap/core';

/**
 * TipTap extension for warning spans (needs_review)
 * Badge is rendered via CSS ::after, not as a nested element
 * Format: <span class="warning-needs-review" data-message="...">text</span>
 */
export const WarningNeedsReview = Mark.create({
    name: 'warningNeedsReview',

    addAttributes() {
        return {
            title: {
                default: null,
                parseHTML: element => element.getAttribute('title'),
                renderHTML: attributes => {
                    if (!attributes.title) {
                        return {};
                    }
                    return { title: attributes.title };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'span.warning-needs-review',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['span', { ...HTMLAttributes, class: 'warning-needs-review' }, 0];
    },
});

/**
 * TipTap extension for caveat spans (non-critical notes)
 * Badge is rendered via CSS ::after, not as a nested element
 * Format: <span class="warning-caveat" data-message="...">text</span>
 */
export const WarningCaveat = Mark.create({
    name: 'warningCaveat',

    addAttributes() {
        return {
            title: {
                default: null,
                parseHTML: element => element.getAttribute('title'),
                renderHTML: attributes => {
                    if (!attributes.title) {
                        return {};
                    }
                    return { title: attributes.title };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                tag: 'span.warning-caveat',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['span', { ...HTMLAttributes, class: 'warning-caveat' }, 0];
    },
});
